import Switch from "@mui/material/Switch";
import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { InputNumber } from "../Common";

export interface props {
	telehealthPromptTime: number;
	setTelehealthPromptTime: Dispatch<SetStateAction<number>>;
	enablOMAppTelehealth: boolean;
	setEnableOMAppTelehealth: Dispatch<SetStateAction<boolean>>;
	enableReceptionAppTelehealth: boolean;
	setEnableReceptionAppTelehealth: Dispatch<SetStateAction<boolean>>;
}
export const Settings = ({
	telehealthPromptTime,
	setTelehealthPromptTime,
	enablOMAppTelehealth,
	setEnableOMAppTelehealth,
	enableReceptionAppTelehealth,
	setEnableReceptionAppTelehealth
}: props) => {
	const onPromptTimeChange = async (event: ChangeEvent<HTMLInputElement>) => {
		console.info(
			"onPromptTimeChange",
			event.target.value,
			isNaN(Number(event.target.value))
		);
		if (!isNaN(Number(event.target.value))) {
			setTelehealthPromptTime(Number(event.target.value));
		}
		return;
	};

	return (
		<div className="ch-card ch-lightgrey-background flex flex-col gap-4 p-4 mb-4">
			<div className="ch-m-text">Settings</div>
			<div className="flex gap-8 mb-8">
				<div className="flex">
					<Switch
						checked={enableReceptionAppTelehealth}
						onChange={(e) => setEnableReceptionAppTelehealth(e.target.checked)}
					/>
					<div className="mt-1 ml-2">Reception app telehealth</div>
				</div>
				<div className="flex">
					<Switch
						checked={enablOMAppTelehealth}
						onChange={(e) => setEnableOMAppTelehealth(e.target.checked)}
					/>
					<div className="mt-1 ml-2">Our Medical app telehealth</div>
				</div>
				<div className="flex">
					<InputNumber
						name="telehealthPatientPromptTime"
						value={telehealthPromptTime}
						min={0}
						width={50}
						handleChange={onPromptTimeChange}
					/>
					<div className="mt-1 ml-2">Patient prompt wait time (mins)</div>
				</div>
			</div>
		</div>
	);
};
